import { render, staticRenderFns } from "./SkillIcons.vue?vue&type=template&id=fe7c9754&"
import script from "./SkillIcons.vue?vue&type=script&lang=js&"
export * from "./SkillIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports